import React, { useState, useEffect } from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { AiOutlineRight } from "react-icons/ai";
import "./RightSideCalendar.css"; // Import the CSS file

export default function RightSideCalendar({ change1 }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [weekDates, setWeekDates] = useState([]);
  const [firstDayOfWeek, setFirstDayOfWeek] = useState(new Date());
  const handlePreviousWeek = () => {
    const previousWeek = new Date(currentDate);
    previousWeek.setDate(previousWeek.getDate() - 7);
    setCurrentDate(previousWeek);
  };

  const handleNextWeek = () => {
    const nextWeek = new Date(currentDate);
    nextWeek.setDate(nextWeek.getDate() + 7);
    setCurrentDate(nextWeek);
  };

  const formatDate = (date) => {
    const day = date.getDate();
    return day < 10 ? `0${day}` : `${day}`;
  };

  const formatMonthYear = (date) => {
    const options = { month: "long", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    const [month, year] = formattedDate.split(" ");
    return `${month}, ${year}`;
  };

  const startOfWeek = new Date(currentDate);
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());


  const currentMonthYear = formatMonthYear(startOfWeek);

  const firstDayOfMonth = new Date(
    startOfWeek.getFullYear(),
    startOfWeek.getMonth(),
    1
  );
  function getWeek(date) {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfWeek = firstDayOfMonth.getDay() || 7; // Sunday: 0 (instead of 7)
    const adjustedDate = date.getDate() + firstDayOfWeek - 1;
    return Math.ceil(adjustedDate / 7);
  }
  // Usage:
  let defaultWeek;
  const currentDate1 = new Date();
  const currentWeekNumber = getWeek(currentDate1);
  defaultWeek = currentWeekNumber
  // const currentWeek = Math.ceil(
  //   (currentDate.getDate() - firstDayOfMonth.getDay()) / 7
  // );
  const currentWeek = Math.ceil((currentDate.getDate() + firstDayOfMonth.getDay() - 1) / 7);
  const handleDateClick = (date) => {
    setSelectedDate(date);
    change1(date);
  };
  function isCurrentWeek(date) {
    const currentDate = new Date();
    const currentWeekNumber = getWeek(currentDate);
    const targetWeekNumber = getWeek(date);
    return currentWeekNumber === targetWeekNumber;
  }

  useEffect(() => {
    let weekDate = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startOfWeek);
      date.setDate(date.getDate() + i);
      weekDate.push(date);
      if (i === 0) {
        setFirstDayOfWeek(date);
      }
    }

    // Set week dates and select the current date by default
    if (weekDate.length > 0) {
      setWeekDates((_) => [...weekDate]);
      setSelectedDate(currentDate);
    }
  }, [currentDate]);

  return (
    <div className="totalocotainerCalender mt-1">
      <div className="d-flex justify-content-center">
        <div className="RightSideMonth"> {currentMonthYear}</div>
      </div>
      <div className="d-flex justify-content-between align-items-center  weekPans">
        <div onClick={() => handlePreviousWeek()}>
          <AiOutlineLeft />
        </div>
        <div className="weekRightSide">Week {currentWeek === 0 ? 5 : currentWeek}</div>
        <div onClick={() => handleNextWeek()}>
          <AiOutlineRight />
        </div>
      </div>

      <div className="d-flex justify-content-center w-100 weeklyDatesPane">
        <div style={{ textAlign: "center", cursor: "pointer" }}>
          {weekDates.map((date, index) => (
            <div
              key={index}
              //Here I added logic for get selected date
              className={`mt-4 
                ${date.getDate() === currentDate.getDate() && isCurrentWeek(date)
                  ? "highlighted"
                  : date.getDay() === 0 ? "sunday ml-2" : "ml-2"}
                ${(selectedDate && date.getDate() === selectedDate.getDate())
                  ? "selecteddatehighlighted"
                  : date.getDay() === 0 ? "sunday ml-2" : "ml-2"}
              `}
              onClick={() => handleDateClick(date)}
            >
              {formatDate(date)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
